import { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { OnboardingContainer } from './components/OnboardingContainer';
import { FeatureFlagProvider } from './providers/featureFlag/featureFlag.provider';

interface OnboardingProps {
  anonymousId?: string;
  isLoadingData: boolean;
}

const Onboarding: FC<OnboardingProps> = observer((props) => {
  const { isLoadingData, anonymousId } = props;
  return (
    <FeatureFlagProvider segmentAnonymousId={anonymousId ?? undefined}>
      <OnboardingContainer isLoadingData={isLoadingData} />
    </FeatureFlagProvider>
  );
});

export default Onboarding;
